import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import './style.css'
import Empresa from './views/empresa'
import Contacto from './views/contacto'
import Home from './views/home'

const App = () => {
  return (
    <Router>
      <div>
        <Route exact component={Empresa} path="/empresa" />
        <Route exact component={Contacto} path="/contacto" />
        <Route exact component={Home} path="/" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
